import _ from 'lodash';
import React from 'react';
import {
    getPrecisePriceWithCurrency,
    getPriceWithDisplayCurrencyByPrecision,
    getFreelancerExchangeRate,
} from 'arbitrip-common/general/utils/Currencies';
import { getPriceValue } from './utils';
import helpers from './helpers';
import { useTranslation } from 'react-i18next';

const SettlePaymentSummary = ({ booking, showEditCommission, onEditCommission, chargeCurrency, profile }) => {
    const { t } = useTranslation();
    const total_net_price = booking?.deal?.cheapopoPricing?.purchase_price;
    const total_client_price = booking.deal?.cheapopoPricing?.cheapopoTotalPrice;

    const total_commission =
        booking?.deal?.cheapopoPricing?.agentPricing?.absolute_margin_total ||
        booking?.deal?.cheapopoPricing?.commissionTotal ||
        0;
    const commission_percentage = helpers.getCommissionPercentage(booking);

    const currency = booking?.deal?.cheapopoPricing?.currency;
    const points_in_currency = booking?.payment?.loyalty?.points_in_currency || 0;
    const total_to_pay = (total_net_price + total_commission || total_client_price) - points_in_currency;

    const additional_currency = chargeCurrency && chargeCurrency !== currency;

    return (
        <div className="change-client-price">
            <div className="pricing-summary">
                <label>{t('Bookings.SettlePayment.PricingSummary')}</label>
                <div className="pricing-item">
                    <div className="price-title">{t('Bookings.SettlePayment.TotalNetPrice')}</div>
                    {getPriceValue(total_net_price, currency, chargeCurrency, profile)}
                </div>
                <div className="pricing-item">
                    <div className="price-title">{t('Bookings.SettlePayment.Commission')}</div>
                    <div className="price-value">
                        {showEditCommission && _.isFunction(onEditCommission) && (
                            <span className="edit-commission" onClick={onEditCommission}>
                                {t('Bookings.SettlePayment.EditCommission')}
                            </span>
                        )}
                        {commission_percentage}%
                    </div>
                </div>
                <div className="pricing-item">
                    <div className="price-title">{t('Bookings.SettlePayment.TotalCommission')}</div>
                    {getPriceValue(total_commission, currency, chargeCurrency, profile)}
                </div>
                <div className="pricing-item bold">
                    <div className="price-title">{t('Bookings.SettlePayment.TotalClientPrice')}</div>
                    {getPriceValue(total_client_price, currency, chargeCurrency, profile)}
                </div>
                {points_in_currency > 0 && (
                    <div className="pricing-item">
                        <div className="price-title">{t('Bookings.SettlePayment.PointsDiscount')}</div>
                        <div className="price-value">{getPrecisePriceWithCurrency(-points_in_currency, currency)}</div>
                    </div>
                )}
                <hr />

                <div className="pricing-item bold sum">
                    <div className="price-title">{t('Bookings.SettlePayment.TotalToPay')}</div>
                    <div className="price-value">
                        {additional_currency ? (
                            <React.Fragment>
                                {getPriceWithDisplayCurrencyByPrecision(
                                    total_to_pay,
                                    getFreelancerExchangeRate(profile, currency, chargeCurrency),
                                    chargeCurrency,
                                    2,
                                )}
                            </React.Fragment>
                        ) : (
                            getPrecisePriceWithCurrency(total_to_pay, currency)
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettlePaymentSummary;
